<app-trip-types-field
  [form]="form()" 
  formControlName="tripType"
/>